module.exports = __webpack_public_path__ + "img/searchEmptyState.a0e56e89.svg";